const variables = {
    typography: {
        segoe: `'Segoe UI Variable Text', sans-serif`,
        gtAmerica: `'GT America', sans-serif`,
    },

    palette: {
        red: '#F4364C',
        blue: '#00529A',
        cream: '#CCC4B8',

        grey: {
            100: '#E9E9E9',
            300: '#CCC',
            500: '#727272',
            800: '#2D2D2D',
            900: '#151515',
            light: '#E9E9E9',
            dark: '#151515',
        },

        white: '#FFF',
        black: '#000',
    },

    borderRadius: {
        sm: 4,
        md: 8,
        lg: 16,
        xl: 30,
    },

    msftHeaderHeight: 54,
    msftHeaderHeightMobile: 88,
};

variables.buttonTheme = {
    light: {
        color: variables.palette.white,
        border: `1px solid ${variables.palette.grey[300]}`,
        background: 'rgba(255, 255, 255, 0.16)',
        backdropFilter: 'blur(76px)',
        transition: 'all 0.3s ease-in-out',
    },
    dark: {
        color: variables.palette.black,
        border: `1px solid ${variables.palette.black}`,
        background: 'rgba(0, 0, 0, 0.16)',
        backdropFilter: 'blur(76px)',
        transition: 'all 0.3s ease-in-out',
    },
};

export default variables;
